<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar
              :icon="getImageDatabaseIcon($route.params.type)"
              >{{
                getImageDatabaseName($route.params.type, false)
              }}</main-sub-page-toolbar
            >
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <div>
              <div class="d-flex mb-1 align-center">
                <v-btn
                  :disabled="$store.state.storeImageDatabase.page <= 1"
                  color="secondary"
                  class="elevation-0"
                  @click="previousPage"
                >
                  <v-icon medium>mdi-arrow-left</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <div>
                  {{ $t("msgPage") }} {{ $store.state.storeImageDatabase.page }}
                </div>
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="
                    $store.state.storeImageDatabase.page >=
                    $store.state.storeImageDatabase.last
                  "
                  color="secondary"
                  class="elevation-0"
                  @click="nextPage"
                >
                  <v-icon medium>mdi-arrow-right</v-icon>
                </v-btn>
              </div>
              <v-toolbar
                class="#505050--text"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; border-bottom: none; background-color: white'
                    : 'border: none; background-color: white'
                "
              >
                <v-text-field
                  clearable
                  class="mx-1"
                  v-model="$store.state.storeImageDatabase.search"
                  append-icon="mdi-magnify"
                  :label="$t('dataGridSearchLabel')"
                  single-line
                  hide-details
                  @keyup.enter="getSearch"
                  @click:append="getSearch"
                  @click:clear="
                    $nextTick(() => {
                      $store.state.storeImageDatabase.search = '';
                      getSearch();
                    })
                  "
                ></v-text-field>
                <v-select
                  class="mt-6 mx-1"
                  v-model="$store.state.storeImageDatabase.category"
                  :items="
                    $store.state.storeImageDatabaseCategory
                      .imageDatabaseCategory
                  "
                  item-text="title"
                  item-value="title"
                  :label="$t('settingsImageDatabaseCategoryTitle')"
                  @change="getCategory"
                ></v-select>
                <v-select
                  class="mt-6 mx-1"
                  v-model="$store.state.storeImageDatabase.order"
                  :items="orderType"
                  item-text="title"
                  item-value="query"
                  :label="$t('dialogImageDatabaseSelectionOrderBy')"
                  @change="getSearch"
                ></v-select>
              </v-toolbar>
              <v-data-table
                :loading-text="$t('lmPleaseWait')"
                class="#505050--text"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; border-top: none; background-color: white'
                    : 'border: none; background-color: white'
                "
                :headers="headers"
                :items="$store.state.storeImageDatabase.imageDatabase"
                :search="search"
                show-expand
                :no-results-text="$t('dataGridSlotNoResults')"
                :no-data-text="$t('dataGridSlotNoData')"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:expanded-item="{ item }">
                  <td :colspan="headers.length" class="py-2">
                    <div class="pt-1 overline">
                      {{ $t("settingsImageDatabasePropertiesTitle") }}
                    </div>
                    <div class="pt-1">
                      {{ item.width }}x{{ item.height }},
                      {{ item.orientation }}, {{ item.counter }},
                      {{ item.rotate }}
                    </div>
                    <div class="pt-1 overline">
                      {{ $t("settingsImageDatabaseKeywordsTitle") }}
                    </div>
                    <div class="pt-1">
                      {{ item.keywords }}
                    </div>
                    <div class="pt-1 overline">
                      {{ $t("msgRecordLastAddedEdited") }}
                    </div>
                    <div class="pt-1 py-2">
                      {{ item.createdTimestamp.seconds | formatDate }} /
                      {{ item.editedTimestamp.seconds | formatDate }}
                    </div>
                  </td>
                </template>
                <template v-slot:item.image="{ item }">
                  <v-img
                    :src="
                      item.image.length > 0 ? item.imagePreview : defaultImage
                    "
                    :style="
                      item.image.length > 0
                        ? 'max-width: 70px'
                        : 'max-width: 50px'
                    "
                  ></v-img>
                </template>
                <template v-slot:item.active="{ item }">
                  <v-icon :color="item.active ? 'success' : 'error'">{{
                    item.active
                      ? "mdi-check-circle-outline"
                      : "mdi-close-circle-outline"
                  }}</v-icon>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div
                    v-if="
                      $store.state.storeAuth.userProfile.isSuperStoreAdmin ||
                      item.client ==
                        $store.state.storeClient.client.basicSettings.name
                    "
                    class="d-flex flex-no-wrap"
                  >
                    <v-icon class="mr-3" @click="copyItem(item)"
                      >mdi-content-copy</v-icon
                    >
                    <v-icon class="mr-3" @click="editItem(item)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon
                      v-if="item.type == G_IMAGE_DATABASE_TYPE_FRAMES"
                      class="mr-3"
                      @click="editCoordinates(item)"
                      >mdi-image-edit</v-icon
                    >
                    <v-icon @click="deleteItemSet(item)">mdi-delete</v-icon>
                  </div>
                </template>
              </v-data-table>
            </div>

            <!-- DELETE CONFIRM DIALOG -->
            <dialog-basic-yes-no
              :active="dialogDelete"
              @clickYes="deleteItem"
              @clickNo="dialogDelete = false"
              icon="mdi-comment-question-outline"
              :title="$t('msgQuestion')"
              >{{ $t("deleteDialogQuestion") }}</dialog-basic-yes-no
            >
          </v-flex>

          <!-- PLEASE WAIT DIALOG -->
          <v-dialog
            v-model="dialogWait"
            persistent
            max-width="400"
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-card-title class="headline">{{
                $t("userNewOrderPleaseWaitTitle")
              }}</v-card-title>
              <v-card-text class="d-flex">
                <v-spacer></v-spacer>
                <v-progress-linear
                  color="primary"
                  height="10"
                  indeterminate
                ></v-progress-linear>
                <v-spacer></v-spacer>
              </v-card-text>
            </v-card>
          </v-dialog>

          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenuImageDatabase' })"
          ></simple-navigation-button>

          <!-- ADD / EDIT DIALOG -->
          <v-dialog
            v-model="dialog"
            max-width="500px"
            persistent
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="primary" v-on="on" dark fixed bottom right rounded>
                <v-icon medium class="mr-1">mdi-plus</v-icon>
                {{ $t("lmBtnAdd") }}
              </v-btn>
            </template>
            <v-form ref="form" v-model="valid">
              <v-card
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? ''
                    : 'border-bottom: 1px solid lightgray'
                "
              >
                <v-card-title
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: #505050'
                      : 'background-color: white; border-bottom: 1px solid lightgray'
                  "
                  :class="
                    getTheme() == 'dark' ? 'white--text' : '#505050--text'
                  "
                  class="title font-weight-regular"
                >
                  <v-icon
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    class="mr-3"
                    medium
                    >{{
                      this.editedIndex == -1 ? "mdi-plus" : "mdi-pencil"
                    }}</v-icon
                  >
                  {{ formTitle }}
                </v-card-title>
                <v-card-text class="py-0 pt-2">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.order"
                          type="number"
                          :label="$t('settingsImageDatabaseOrderTitle')"
                          :rules="[validateRequired(), validateIsNumber()]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          v-model="editedItem.category"
                          :items="
                            $store.state.storeImageDatabaseCategory
                              .imageDatabaseCategory
                          "
                          item-text="title"
                          item-value="title"
                          :label="$t('settingsImageDatabaseCategoryTitle')"
                          :rules="[validateRequired()]"
                          dense
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.title"
                          :label="$t('settingsImageDatabaseNameTitle')"
                          :rules="[validateRequired(), validateMaxLength(50)]"
                          :counter="50"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.keywords"
                          :label="$t('settingsImageDatabaseKeywordsTitle')"
                          :rules="[validateRequired(), validateMaxLength(350)]"
                          :counter="350"
                          :hint="$t('settingsImageDatabaseKeywordsHintTitle')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          item-text="title"
                          item-value="langShort"
                          :items="flagItemsAll"
                          :label="$t('settingsImageDatabaseLanguageTitle')"
                          v-model="editedItem.language"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-file-input
                          :clearable="true"
                          multiple
                          small-chips
                          accept="image/jpeg, image/png"
                          prepend-icon="mdi-camera"
                          v-model="editedItem.image"
                          class="mt-0 pa-0"
                          :label="$t('settingsImageDatabaseImageBatchTitle')"
                        ></v-file-input>
                      </v-flex>
                      <v-flex
                        v-show="
                          $store.state.storeAuth.userProfile.isSuperStoreAdmin
                        "
                        xs12
                      >
                        <v-select
                          item-text="client"
                          item-value="client"
                          :items="[
                            { client: '/' },
                            {
                              client:
                                $store.state.storeClient.client.basicSettings
                                  .name,
                            },
                          ]"
                          v-model="editedItem.client"
                          :label="$t('settingsImageDatabaseOwnerTitle')"
                          dense
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.active"
                          :label="$t('settingsPhotoGiftActiveTitle')"
                        ></v-switch>
                      </v-flex>
                      <v-flex
                        xs12
                        v-show="
                          $route.params.type ==
                            G_IMAGE_DATABASE_TYPE_BACKGROUNDS ||
                          $route.params.type == G_IMAGE_DATABASE_TYPE_FRAMES
                        "
                      >
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.rotate"
                          :label="$t('settingsImageDatabaseRotateTitle')"
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions
                  :class="
                    getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                  "
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                      : 'background-color: white; border-top: 1px solid lightgray;'
                  "
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    class="my-1"
                    text
                    @click="
                      close();
                      refresh();
                    "
                    >{{ $t("addEditFormCancelButton") }}</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn @click="save" color="primary" dark>
                    <v-icon medium class="mr-1">mdi-content-save</v-icon>
                    {{ $t("addEditFormSaveButton") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>

          <!-- EDIT IMAGE COORDINATES DIALOG -->
          <v-dialog
            v-model="dialogEditImageCoordinates"
            persistent
            style="z-index: 2000"
            :fullscreen="true"
            :scrollable="true"
            transition="dialog-bottom-transition"
          >
            <v-card
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'
              "
            >
              <v-card-title
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: #505050'
                    : 'background-color: white; border-bottom: 1px solid lightgray'
                "
                :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
                class="title font-weight-regular"
              >
                <v-icon
                  :class="
                    getTheme() == 'dark' ? 'white--text' : 'primary--text'
                  "
                  class="mr-3"
                  medium
                  >mdi-border-outside</v-icon
                >
                {{ $t("settingsPhotoGiftPreviewImageCoodrinatesTitle") }}
                <v-spacer></v-spacer>
                <v-btn
                  text
                  medium
                  @click="dialogEditImageCoordinates = false"
                  style="min-width: 0; width: 20px"
                >
                  <v-icon
                    medium
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    >mdi-close-box</v-icon
                  >
                </v-btn>
              </v-card-title>
              <div class="d-flex ma-3 mb-1 pa-0">
                <v-spacer></v-spacer>
                <v-btn
                  middle
                  text
                  outlined
                  color="secondary"
                  class="mx-1 elevation-0"
                  @click="resetCurrentItem"
                >
                  <v-icon class="mx-1">mdi-restore</v-icon>
                  {{ $t("lmBtnReset") }}
                </v-btn>
                <v-btn
                  middle
                  text
                  outlined
                  color="secondary"
                  class="mx-1 elevation-0"
                  @click="setCanvasItem('rect')"
                >
                  <v-icon class="mx-1">mdi-square</v-icon>
                </v-btn>
                <v-btn
                  middle
                  text
                  outlined
                  color="secondary"
                  class="mx-1 elevation-0"
                  @click="setCanvasItem('circle')"
                >
                  <v-icon class="mx-1">mdi-circle</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
              </div>
              <v-card-text class="d-flex ma-0 pa-2">
                <div
                  id="canvasEditImageCoordinates"
                  class="d-flex"
                  style="width: 100%"
                >
                  <v-spacer></v-spacer>
                  <canvas
                    ref="fabricEditImageCoordinates"
                    style="object-fit: contain; border: 1px solid forestgreen"
                  ></canvas>
                  <v-spacer></v-spacer>
                </div>
              </v-card-text>
              <v-card-actions
                :class="
                  getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                    : 'background-color: white; border-top: 1px solid lightgray;'
                "
              >
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  class="my-1 mr-5"
                  text
                  @click="dialogEditImageCoordinates = false"
                  >{{ $t("addEditFormCancelButton") }}</v-btn
                >
                <v-btn
                  @click="saveEditImageCoordinates()"
                  color="primary"
                  dark
                  class="ml-5"
                >
                  <v-icon medium class="mr-1">mdi-content-save</v-icon>
                  {{ $t("addEditFormSaveButton") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import {
  uploadImageToStorage,
  uploadPreviewImageToStorage,
} from "@/mixins/firebaseUtils";
import { v4 as uuidv4 } from "uuid";
import "firebase/functions";
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import { readNewImageDatabaseFile } from "@/mixins/modPhotoOrderUploadService";
import { flagLangAll } from "@/localization/flagLang";
import {
  G_IMAGE_DATABASE_TYPE_FRAMES,
  G_IMAGE_DATABASE_TYPE_BACKGROUNDS,
} from "@/constants";
import { fabric } from "fabric";
import "fabric-customise-controls";

export default {
  name: "settingsImageDatabase",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    DialogBasicYesNo,
    SimpleNavigationButton,
  },
  data() {
    return {
      valid: true,
      netBackImage: require("@/assets/netBack.png"),
      defaultImage: require("@/assets/giftCategoryDefault.jpg"),
      resizeIconTR: require("@/assets/resize-icon-tr.svg"),
      resizeIconTL: require("@/assets/resize-icon-tl.svg"),
      resizeIconBR: require("@/assets/resize-icon-br.svg"),
      resizeIconBL: require("@/assets/resize-icon-bl.svg"),
      resizeIconMR: require("@/assets/resize-icon-mr.svg"),
      resizeIconMT: require("@/assets/resize-icon-mt.svg"),
      resizeIconMB: require("@/assets/resize-icon-mb.svg"),
      resizeIconML: require("@/assets/resize-icon-ml.svg"),
      rotateIconSVG: require("@/assets/rotate-icon.svg"),
      flagItemsAll: flagLangAll,
      search: "",
      dialog: false,
      dialogDelete: false,
      dialogDeleteId: "",
      dialogWait: false,
      dialogEditImageCoordinates: false,
      canvasPreviewTemplate: null,
      currentId: "",
      currentItem: {},
      headers: [
        {
          text: this.$t("settingsImageDatabaseOrderTitle"),
          align: "center",
          value: "order",
          sortable: false,
        },
        {
          text: this.$t("settingsImageDatabaseCategoryTitle"),
          align: "center",
          value: "category",
          sortable: false,
        },
        {
          text: this.$t("settingsImageDatabaseNameTitle"),
          align: "center",
          value: "title",
          sortable: false,
        },
        {
          align: "center",
          value: "image",
          sortable: false,
        },
        {
          text: this.$t("settingsImageDatabaseLanguageTitle"),
          align: "center",
          value: "language",
          sortable: false,
        },
        {
          text: this.$t("settingsImageDatabaseOwnerTitle"),
          align: "center",
          value: "client",
          sortable: false,
        },
        {
          text: this.$t("settingsImageDatabaseActiveTitle"),
          align: "center",
          value: "active",
          sortable: false,
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "actions",
        },
        {
          text: this.$t("msgMore"),
          value: "data-table-expand",
          sortable: false,
        },
      ],
      editedIndex: -1,
      editedItem: {
        order: 1,
        title: "",
        client: this.$store.state.storeClient.client.basicSettings.name,
        active: true,
        category: "",
        keywords: "",
        rotate: false,
        createdTimestamp: new Date(),
        editedTimestamp: new Date(),
        image: [],
        imageURL: "",
        imagePreview: "",
      },
      defaultItem: {
        order: 1,
        title: "",
        client: this.$store.state.storeClient.client.basicSettings.name,
        active: true,
        rotate: false,
        category: "",
        keywords: "",
        createdTimestamp: new Date(),
        editedTimestamp: new Date(),
        image: [],
        imageURL: "",
        imagePreview: "",
      },
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("addEditFormAddingTitle")
        : this.$t("addEditFormEditingTitle");
    },
  },
  methods: {
    deleteItemSet(item) {
      this.dialogDelete = true;
      this.dialogDeleteId = item;
    },
    async deleteItem() {
      this.dialogDelete = false;
      this.dialogWait = true;

      let deleteImage = firebase
        .functions()
        .httpsCallable("deleteImageFromStorage");

      try {
        deleteImage([
          this.dialogDeleteId.imageURL,
          this.dialogDeleteId.imagePreviewURL,
        ])
          .then((res) => {
            this.dialogWait = false;
            console.log(res);

            this.$store.dispatch("removeImageDatabase", this.dialogDeleteId.id);
            this.dialogDeleteId = "";

            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessDelete"),
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        this.dialogWait = false;
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    copyItem(item) {
      item.image2 = item.image; // duplikat, da ne izgine slika v prikazu baze
      item.image = [];
      item.keywords = item.keywords.join(",");
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex =
        this.$store.state.storeImageDatabase.imageDatabase.indexOf(item);
      item.image2 = item.image; // duplikat, da ne izgine slika v prikazu baze
      item.image = [];
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    nextPage() {
      this.$store.dispatch("getImageDatabase", {
        type: this.$route.params.type,
        client: this.$store.state.storeClient.client.basicSettings.name,
        mode: "edit",
        refresh: "getNext",
      });
    },
    previousPage() {
      this.$store.dispatch("getImageDatabase", {
        type: this.$route.params.type,
        client: this.$store.state.storeClient.client.basicSettings.name,
        mode: "edit",
        refresh: "getPrevious",
      });
    },
    getCategory() {
      this.$store.commit("imageDatabaseSetAll", {
        page: 1,
        last: 9999999,
        firstQuery: "",
        lastQuery: "",
        category: this.$store.state.storeImageDatabase.category,
        search:
          this.$store.state.storeImageDatabase.search == null
            ? ""
            : this.$store.state.storeImageDatabase.search,
        lang: this.$store.state.storeImageDatabase.lang,
        order: this.$store.state.storeImageDatabase.order,
      });
      this.refresh();
    },
    getSearch() {
      this.$store.commit("imageDatabaseSetAll", {
        page: 1,
        last: 9999999,
        firstQuery: "",
        lastQuery: "",
        category: this.$store.state.storeImageDatabase.category,
        search: this.$store.state.storeImageDatabase.search,
        lang: this.$store.state.storeImageDatabase.lang,
        order: this.$store.state.storeImageDatabase.order,
      });
      this.refresh();
    },
    resetAll() {
      this.$store.state.storeImageDatabase.imageDatabase = [];
      this.$store.state.storeImageDatabase.pageSize = 25;
      this.$store.state.storeImageDatabase.order = "add";
      this.$store.state.storeImageDatabase.lang = "all";
      this.$store.state.storeImageDatabase.search = "";

      this.$store.dispatch("getImageDatabaseCategory", {
        type: this.$route.params.type,
        client: this.$store.state.storeClient.client.basicSettings.name,
        mode: "edit",
        addEmptyCat: "/",
      });

      this.$store.commit("imageDatabaseSetAll", {
        page: 1,
        last: 9999999,
        firstQuery: "",
        lastQuery: "",
        category: "/",
        search: "",
        lang: "all",
        order: this.$store.state.storeImageDatabase.order,
      });
      this.refresh();
    },
    refresh() {
      this.dialog = false;
      this.$store.dispatch("getImageDatabase", {
        type: this.$route.params.type,
        client: this.$store.state.storeClient.client.basicSettings.name,
        mode: "edit",
        refresh: "refresh",
      });
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.dialog = false;
        this.dialogWait = true;

        if (this.editedIndex > -1) {
          try {
            let tItem = this.editedItem;

            if (Array.isArray(tItem.image)) {
              delete tItem.image;
            } else {
              let img = await readNewImageDatabaseFile(this.editedItem.image);

              Object.assign(tItem, {
                width: img.image.attr.width,
                height: img.image.attr.height,
                orientation: img.image.attr.orientation,
                aRatio: img.image.attr.aRatio,
                fType: img.image.attr.type,
                imagePreview: img.image.path,
                image: img.image.attr,
              });
            }

            await this.$store.dispatch(
              "editImageDatabase",
              Object.assign(tItem, {
                type: this.$route.params.type,
              })
            );

            this.$store.dispatch("getImageDatabase", {
              type: this.$route.params.type,
              client: this.$store.state.storeClient.client.basicSettings.name,
              mode: "edit",
              refresh: "refresh",
            });

            this.dialogWait = false;

            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessEdit"),
            });
          } catch (error) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        } else {
          try {
            let tItem = this.editedItem;
            let images = this.editedItem.image;

            tItem.keywords = tItem.keywords.toLowerCase();
            tItem.keywords = tItem.keywords.replace(" ", "");
            tItem.keywords = tItem.keywords.split(","); // String => Array

            let client = this.editedItem.client;

            // nastavimo vrednosti
            delete tItem.image;
            delete tItem.image2;
            delete tItem.imagePreview;
            delete tItem.imagePreviewURL;
            delete tItem.imageURL;
            delete tItem.id;
            tItem.order = Number(tItem.order); // String => Number
            tItem.createdTimestamp = firebase.firestore.Timestamp.fromDate(
              new Date()
            );
            tItem.editedTimestamp = firebase.firestore.Timestamp.fromDate(
              new Date()
            );

            // CREATE AN ARRAY OF PROMISES
            for (let file of images) {
              let rItem = tItem;
              let img = await readNewImageDatabaseFile(file);
              let fileName = (client == "/" ? "app" : client) + "-" + uuidv4();

              Object.assign(rItem, {
                width: img.image.attr.width,
                height: img.image.attr.height,
                orientation: img.image.attr.orientation,
                aRatio: img.image.attr.aRatio,
                fType: img.image.attr.type,
                imagePreview: img.image.path,
                image: img.image.attr,
                counter: 0,
              });

              console.log("IMAGE ATTRS", img.image.attr.width);

              if (rItem.type == G_IMAGE_DATABASE_TYPE_FRAMES)
                rItem.coordinates = {
                  mode: "rect",
                  angle: 0,
                  width: 150,
                  height: 150,
                  left: 100,
                  top: 100,
                };

              // upload preview image
              let imagePreviewURL = await uploadPreviewImageToStorage(
                "imageDatabase/",
                fileName,
                img.image.path
              );
              console.log("PREVIEW UPLOAD", rItem.width);
              if (imagePreviewURL.success) {
                rItem.imagePreview = imagePreviewURL.url;
                rItem.imagePreviewURL = "imageDatabase/" + fileName + "-p";
              } else {
                rItem.imagePreview = "";
                rItem.imagePreviewURL = "";
              }

              // upload main image
              let imageURL = await uploadImageToStorage(
                "imageDatabase/" + fileName,
                img.image.attr
              );
              console.log("MAIN UPLOAD", rItem.width);
              if (imageURL.success) {
                rItem.image = imageURL.url;
                rItem.imageURL = "imageDatabase/" + fileName;
              } else {
                rItem.image = "";
                rItem.imageURL = "";
              }

              rItem.type = this.$route.params.type;
              console.log("FINISH", rItem.imageURL, rItem.imagePreviewURL);

              await this.$store.dispatch("addImageDatabase", rItem);
            }
            this.dialogWait = false;
          } catch (error) {
            this.dialogWait = false;
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        }
        this.close();
      }
    },
    async saveEditImageCoordinates() {
      this.dialogEditImageCoordinates = false;
      this.dialogWait = true;

      let coords = {};

      this.canvasPreviewTemplate.canvas.getObjects().filter((o) => {
        if (o.get("type") === "rect") {
          coords = {
            left: Math.round(o.left),
            top: Math.round(o.top),
            width: Math.round(o.getScaledWidth()),
            height: Math.round(o.getScaledHeight()),
            angle: Math.round(o.angle),
            mode: o.mode,
          };
        }
      });

      try {
        await this.$store.dispatch("saveFrameDimensions", {
          id: this.currentId,
          coordinates: coords,
        });
        this.refresh();
        this.$store.commit({
          type: "showSnackbar",
          color: "success",
          message: this.$t("msgSuccessEdit"),
        });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
      }

      this.dialogWait = false;
    },
    resetCurrentItem() {
      this.editCoordinates(this.currentItem);
    },
    editCoordinates(item) {
      console.log(item);
      this.dialogEditImageCoordinates = true;
      this.currentId = item.id;
      this.currentItem = item;

      if (this.canvasPreviewTemplate)
        this.canvasPreviewTemplate.canvas.dispose();
      this.canvasPreviewTemplate = {};

      setTimeout(() => {
        // ustvarimo nov fabricCanvas
        this.canvasPreviewTemplate.canvas = new fabric.Canvas(
          this.$refs.fabricEditImageCoordinates,
          {
            width: item.width,
            height: item.height,
            cRatio: item.aRatio,
            selection: false,
            enableRetinaScaling: false,
            renderOnAddRemove: true,
          }
        );

        this.canvasPreviewTemplate.canvas.setBackgroundImage(
          item.image,
          this.canvasPreviewTemplate.canvas.requestRenderAll.bind(
            this.canvasPreviewTemplate.canvas
          ),
          {
            // Needed to position backgroundImage at 0/0
            originX: "left",
            originY: "top",
            crossOrigin: "anonymous",
          }
        );

        // najprej uveljavimo dimenzije za width, da bomo potem lahko izračunali še height
        this.canvasPreviewTemplate.canvas.setDimensions(
          { width: "100%", height: "1px" },
          { cssOnly: true }
        );

        // pridobimo realni width
        let rw =
          document.getElementById("canvasEditImageCoordinates").offsetWidth /
          this.canvasPreviewTemplate.canvas.cRatio;

        // pridobimo realni height
        let rh =
          document.getElementById("canvasEditImageCoordinates").offsetHeight /
          (this.canvasPreviewTemplate.canvas.height /
            this.canvasPreviewTemplate.canvas.width);

        console.log(
          document.getElementById("canvasEditImageCoordinates").offsetHeight,
          this.canvasPreviewTemplate.canvas.height,
          this.canvasPreviewTemplate.canvas.width
        );
        console.log(rw + " X " + rh);

        if (
          this.canvasPreviewTemplate.canvas.width < rw &&
          this.canvasPreviewTemplate.canvas.height < rh
        ) {
          this.canvasPreviewTemplate.canvas.setDimensions(
            {
              width: this.canvasPreviewTemplate.canvas.width + "px",
              height: this.canvasPreviewTemplate.canvas.height + "px",
            },
            { cssOnly: true }
          );
        } else if (
          document.getElementById("canvasEditImageCoordinates").offsetHeight <=
          rw
        ) {
          // če je potreben scroll potem nastavimo višino kot glavno stranico za prikaz
          this.canvasPreviewTemplate.canvas.setDimensions(
            {
              width: rh + "px",
              height: "100%",
            },
            { cssOnly: true }
          );
        }
        // sicer izrišemo glavno stranico kot width
        // dodamo še izračunani height
        else
          this.canvasPreviewTemplate.canvas.setDimensions(
            { width: "100%", height: rw + "px" },
            { cssOnly: true }
          );

        let rectangle = null;
        if (
          Number(item.coordinates.width) <= 0 ||
          Number(item.coordinates.height) <= 0
        ) {
          rectangle = new fabric.Rect({
            mode: "rect",
            width: item.width / 3,
            height: item.height / 3,
            top: item.height / 2,
            left: item.width / 2,
            centeredScaling: false,
            angle: 0,
            originX: "center",
            originY: "center",
            fill: "rgba(100,200,200,0.35)",
            stroke: "red",
            strokeWidth: 1,
          });
        } else
          rectangle = new fabric.Rect({
            mode: item.coordinates.mode,
            width: item.coordinates.width,
            height: item.coordinates.height,
            top: item.coordinates.top,
            left: item.coordinates.left,
            centeredScaling: false,
            angle: item.coordinates.angle,
            originX: "center",
            originY: "center",
            fill: "rgba(100,200,200,0.35)",
            stroke: "red",
            strokeWidth: 1,
          });

        rectangle.setControlsVisibility({
          tl: true,
          tr: true,
          bl: true,
          br: true,
          ml: true,
          mt: true,
          mr: true,
          mb: true,
          mtr: true,
        });

        rectangle.set({
          //centeredScaling: true,
          rotatingPointOffset: this.canvasPreviewTemplate.canvas.width / 25,
          borderColor: "rgba(255,0,0,0.5)",
          cornerSize: this.$vuetify.breakpoint.smAndUp
            ? this.canvasPreviewTemplate.canvas.width / 50
            : this.canvasPreviewTemplate.canvas.width / 12,
          cornerShape: "rect",
          cornerStrokeColor: "rgba(0,0,0,0)",
          borderScaleFactor: this.canvasPreviewTemplate.canvas.width / 200,
          transparentCorners: true,
        });

        rectangle.customiseCornerIcons({
          tl: {
            icon: this.resizeIconTL,
          },
          tr: {
            icon: this.resizeIconTR,
          },
          bl: {
            icon: this.resizeIconBL,
          },
          br: {
            icon: this.resizeIconBR,
          },
          ml: {
            icon: this.resizeIconML,
          },
          mt: {
            icon: this.resizeIconMT,
          },
          mr: {
            icon: this.resizeIconMR,
          },
          mb: {
            icon: this.resizeIconMB,
          },
          // only is hasRotatingPoint is not set to false
          mtr: {
            icon: this.rotateIconSVG,
          },
        });

        if (item.coordinates.mode == "circle") {
          rectangle.clipPath = new fabric.Ellipse({
            top: -Number(item.coordinates.height) / 2,
            left: -Number(item.coordinates.width) / 2,
            rx: Number(item.coordinates.width) / 2,
            ry: Number(item.coordinates.height) / 2,
          });
        }

        // Render the Rect in canvas
        this.canvasPreviewTemplate.canvas.add(rectangle);

        let gridSizeX = item.width / 4;
        let gridSizeY = item.height / 4;
        let gridoption = {
          stroke: "#00000080",
          strokeWidth: 2,
          strokeDashArray: [15, 15],
        };
        let gridLines = [];
        for (let i = Math.ceil(item.width / gridSizeX); i--; ) {
          gridLines.push(
            new fabric.Line([gridSizeX * i, 0, gridSizeX * i, 5000], gridoption)
          );
        }
        for (let i = Math.ceil(item.height / gridSizeY); i--; ) {
          gridLines.push(
            new fabric.Line([0, gridSizeY * i, 5000, gridSizeY * i], gridoption)
          );
        }
        let gridGroup = new fabric.Group(gridLines, {
          selectable: false,
          evented: false,
        });
        gridGroup.addWithUpdate();
        this.canvasPreviewTemplate.canvas.insertAt(gridGroup, 0);

        this.canvasPreviewTemplate.canvas.requestRenderAll();
      }, 500);
    },
    setCanvasItem(mode) {
      this.canvasPreviewTemplate.canvas.getObjects().filter((o) => {
        if (o.get("type") === "rect") {
          o.mode = mode;
          o.dirty = true;
          if (mode == "circle") {
            o.clipPath = new fabric.Ellipse({
              top: -Number(o.height) / 2,
              left: -Number(o.width) / 2,
              rx: Number(o.width) / 2,
              ry: Number(o.height) / 2,
            });
          } else {
            o.clipPath = "";
          }
          this.canvasPreviewTemplate.canvas.requestRenderAll();
        }
      });
      console.log("set", mode);
    },
  },
  created() {
    this.G_IMAGE_DATABASE_TYPE_FRAMES = G_IMAGE_DATABASE_TYPE_FRAMES;
    this.G_IMAGE_DATABASE_TYPE_BACKGROUNDS = G_IMAGE_DATABASE_TYPE_BACKGROUNDS;
    this.resetAll();
  },
};
</script>